import { observer } from 'mobx-react-lite';
import {
  Form,
  Input,
  Dropdown,
  Button,
  Grid,
  ButtonGroup,
  ButtonOr,
  InputOnChangeData,
  Modal,
  ModalHeader,
  ModalContent,
  ModalActions,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react';
import {
  formFields,
  handleDateFormat,
} from '../../../app/stores/CRMStore/types';
import { useStore } from '../../../app/stores/store';
import {
  createCRMAsset,
  createCRMAssetInitialState,
} from '../../../app/models/Restoration';
import { toast } from 'react-toastify';
import agent from '../../../app/api/agent';
import { v4 as uuid } from 'uuid';

// Define the types for the props and the state
interface Option {
  key: string;
  text: string;
  value: string;
}

const CrmFormFields = () => {
  const { CRMStore,dashboardStore:{dashboard} } = useStore();
  const {
    assetTracking: { SelectedRowFormData },
  } = CRMStore;
  // const [formData, setFormData] = useState<createCRMAsset>(createCRMAssetInitialState);

  const [loading, setLoading] = useState(false);
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    { name, value }: InputOnChangeData,
  ) => {
    CRMStore.assetTracking.SelectedRowFormData = {
      ...CRMStore.assetTracking.SelectedRowFormData,
      [name]: value,
    };
  };

  const handleDropdownChange = (
    e: React.SyntheticEvent,
    { name, value }: { name: string; value: string },
  ) => {
    CRMStore.assetTracking.SelectedRowFormData = {
      ...CRMStore.assetTracking.SelectedRowFormData,
      [name]: value,
    };
  };

  const renderField = (field: any, options: Option[] = []) => {
    switch (field.type) {
      case 'input':
        return (
          <Input
            placeholder={field.placeholder}
            style={{ width: '100%' }}
            name={field.name}
            value={(SelectedRowFormData as any)[field.name] || ''}
            onChange={handleInputChange} // Use the correct handler
            // readOnly={user?.roleName === 'CRM' ? false : true}
          />
        );
      case 'dropdown':
        return (
          <Dropdown
            placeholder={field.placeholder}
            style={{ width: '100%' }}
            name={field.name}
            value={(SelectedRowFormData as any)[field.name] || ''}
            options={options}
            onChange={handleDropdownChange as any}
            clearable
            fluid
            selection
            multiple={field.name === 'category'}
          />
        );
      case 'date':
        return (
          <DatePicker
            placeholderText={field.placeholder}
            className="datepicker"
            selected={
              new Date((SelectedRowFormData as any)[field.name]) || new Date()
            }
            dateFormat="MM-dd-yyyy"
            onChange={(date) =>
              (CRMStore.assetTracking.SelectedRowFormData = {
                ...CRMStore.assetTracking.SelectedRowFormData,
                [field.name]: date,
              })
            }
          />
        );
      default:
        return null;
    }
  };

  const handleSaveForm = async () => {
    try {
      setLoading(true);
      const payload: createCRMAsset = Object.entries(
        SelectedRowFormData,
      ).reduce(
        (acc, [key, value]) => {
          (acc as any)[key] =
            key.includes('date') && value instanceof Date
              ? handleDateFormat(value)
              : key === 'category' && Array.isArray(value)
                ? value.length === 1
                  ? value[0] // Single value in the category array
                  : value.join(', ') // Multiple values joined by commas
                : value; // Default case for other keys
          return acc;
        },
        {} as createCRMAsset, // Initial value with correct type
      );
      CRMStore.assetTracking.isField === 'Add'
        ? await agent.CRMAssetTracking.createCRMAsset({
            ...{ id: uuid() },
            ...payload,
          })
        : await agent.CRMAssetTracking.updateCRMAsset({
            ...{ id: uuid() },
            ...payload,
          });
          if(dashboard.searchfilterparams === null){
            CRMStore.handleCrmAssetTracking(1,10,[]);
          }else{
            CRMStore.handleCrmAssetSearch(dashboard.searchfilterparams);
          }
             
      toast.success('Data updated successfully');
      setLoading(false);
      CRMStore.assetTracking.isField = '';
      CRMStore.assetTracking.SelectedRowFormData = createCRMAssetInitialState;
    } catch (error) {
      console.log(error);
      setLoading(false);
      CRMStore.assetTracking.isField = '';
    }
  };
  return (
    <Modal
      open={
        CRMStore.assetTracking.isField === 'Add' ||
        CRMStore.assetTracking.isField === 'Edit'
      }
      style={{ width: '80vw' }}
    >
      <ModalHeader>CRM Asset Tracking</ModalHeader>
      <ModalContent style={{ height: '44vh' }}>
        <Form>
          <Grid columns={5}>
            {formFields
              .map((e) => {
                const options =
                  e.name === 'department' || e.name === 'asset_Moved_To'
                    ? CRMStore.assetTracking.deptList
                    : e.options;
                return {
                  ...e,
                  options, // Use the updated options here
                };
              })
              .map((field) => (
                <>
                  {CRMStore.assetTracking.isField === 'Add' &&
                  field.name === 'handover_date' ? (
                    <></>
                  ) : (
                    <Grid.Column>
                      <Form.Field>
                        <label>{field.label}</label>
                        {renderField(field, field.options as Option[])}
                      </Form.Field>
                    </Grid.Column>
                  )}
                </>
              ))}
          </Grid>
        </Form>
      </ModalContent>
      <ModalActions>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <ButtonGroup>
            <Button
              onClick={() => {
                // setFormVisible(false);
                CRMStore.assetTracking.isField = '';
                setLoading(false);
              }}
            >
              Close
            </Button>
            <ButtonOr />
            <Button positive onClick={() => handleSaveForm()} loading={loading}>
              Save
            </Button>
          </ButtonGroup>
        </div>
      </ModalActions>
    </Modal>
  );
};

export default observer(CrmFormFields);
